// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../index.generated';
export const ComponentButtonFragmentDoc = `
    fragment componentButton on ComponentButton {
  __typename
  text
  link {
    ...link
  }
  alignment
  style {
    type
    size
    color
    width
    linkSize
    topSpacing
    bottomSpacing
  }
  icon {
    position
    icon
  }
}
    `;